import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Sun, Moon } from "lucide-react";
import { useTheme } from "@/contexts/ThemeContext";

/**
 * Interruttore Light/Dark stile macOS/iOS.
 * `surface` descrive lo sfondo su cui il pulsante poggia ORA (non il tema globale)
 * cosi' resta leggibile sia dentro un pannello scuro (login hero) sia su uno chiaro (sidebar).
 */
export default function ThemeToggle({ surface = "light", className = "" }) {
  const { isDark, toggleTheme } = useTheme();
  const onDark = surface === "dark";

  return (
    <button
      data-testid="theme-toggle-btn"
      onClick={toggleTheme}
      aria-label={isDark ? "Passa al tema chiaro" : "Passa al tema scuro"}
      className={`relative inline-flex items-center gap-2 px-2.5 py-1.5 rounded-full border text-sm transition-colors ${
        onDark ? "border-white/20 text-white/90 hover:bg-white/10" : "border-border text-foreground hover:bg-accent"
      } ${className}`}
    >
      <span className="relative w-4 h-4 inline-flex items-center justify-center overflow-hidden">
        <AnimatePresence mode="wait" initial={false}>
          {isDark ? (
            <motion.span key="sun" initial={{ rotate: -90, opacity: 0 }} animate={{ rotate: 0, opacity: 1 }}
              exit={{ rotate: 90, opacity: 0 }} transition={{ duration: 0.25 }} className="absolute inset-0 flex items-center justify-center">
              <Sun className="w-4 h-4" />
            </motion.span>
          ) : (
            <motion.span key="moon" initial={{ rotate: 90, opacity: 0 }} animate={{ rotate: 0, opacity: 1 }}
              exit={{ rotate: -90, opacity: 0 }} transition={{ duration: 0.25 }} className="absolute inset-0 flex items-center justify-center">
              <Moon className="w-4 h-4" />
            </motion.span>
          )}
        </AnimatePresence>
      </span>
      <span className="font-medium">{isDark ? "Dark" : "Light"}</span>
    </button>
  );
}
